import { render, staticRenderFns } from "./OfferCard.htm?vue&type=template&id=0c5bb0e8&scoped=true&"
import script from "./OfferCard.ts?vue&type=script&lang=js&"
export * from "./OfferCard.ts?vue&type=script&lang=js&"
import style0 from "./OfferCard.scss?vue&type=style&index=0&id=0c5bb0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bb0e8",
  null
  
)

export default component.exports